import organisationService from '../../../services/organisation/OrganisationService';
import relationshipService from '../../../services/relationship/RelationshipService';
import enrollmentService from '../../../services/enrollment';
import {captureError} from '../../../utils/log';
import {getSearchValues} from '../../../utils/search';
import {status} from '../../../utils/constant';
import history from '../../../history/history';

export const getDepositor = organisationId => new Promise(resolve => {
  organisationService.get(organisationId)
    .then(organisation => {
      resolve(organisation.depositor);
    })
    .catch(error => {
      captureError('Error while getting organisation details', error);
      resolve(false);
    });
});

export const getClients = params => new Promise((resolve, reject) => {
  const {queryString = '', page = 0} = getSearchValues(history.location.search);

  const searchParams = [
    params.organisationId,
    status.ACCEPTED,
    params.userId,
    queryString,
    page,
    params.pageSize
  ];

  relationshipService.searchClientsByQuery(...searchParams)
    .then(({relationships, totalCount}) => {
      const clients = relationships.map(relationship => ({
        ...relationship.client,
        favorite: relationship.favorite,
        relationshipId: relationship.relationshipId
      }));

      resolve({clients, totalCount});
    })
    .catch(error => {
      captureError('Error while searching for clients', error);
      reject();
    });
});

export function getInvitations(organisationId) {
  return enrollmentService.network.getInvitationsSentToClient(organisationId);
}
